import TabGroup from './TabGroup';
import TextSmall from '../common/TextSmall';
import SingleInvoice from './SingleInvoice';
import Text from '../common/Text';

const AllInvoices = ({
  filteredInvoicesList,
  filteredInvoicesData,
  selectedInvoiceFolioId,
  setSelectedInvoiceFolioId,
  selectedInvoice,
  setEditInvoiceAddressMode,
}) => {
  if (!filteredInvoicesData) {
    return (
      <div className="mt-12 flex flex-col gap-6 py-2">
        No invoices to display.
      </div>
    );
  }

  const invoiceLabelsData = filteredInvoicesData?.map((invoice, index) => ({
    label: `Invoice #${index + 1}`,
    folioId: invoice?.folioId,
  }));

  return (
    <div className="mt-12 flex flex-col gap-6 py-2">
      <div className="mb-3 mt-1">
        <Text>
          <span>You have </span>
          <span className="font-bold">{invoiceLabelsData.length}</span>
          {invoiceLabelsData.length === 1 && (<span> invoice.</span>)}
          {invoiceLabelsData.length > 1 && (<span> invoices.</span>)}
        </Text>
      </div>
      <TabGroup
        invoiceLabelsData={invoiceLabelsData}
        selectedInvoiceFolioId={selectedInvoiceFolioId}
        setSelectedInvoiceFolioId={setSelectedInvoiceFolioId}
      />
      {selectedInvoice && (
        <SingleInvoice
          folioId={selectedInvoice.folioId}
          invoiceDate={selectedInvoice.invoiceDate}
          total={
            filteredInvoicesList.find(
              (invoiceListItem) => invoiceListItem.folioId === selectedInvoice.folioId,
            ).subTotal
          }
          guestData={selectedInvoice.to}
          lineItems={selectedInvoice.lineItems.lineItems}
          taxDetails={selectedInvoice.taxDetails}
          setEditInvoiceAddressMode={setEditInvoiceAddressMode}
        />
      )}
      <div className="pl-3">
        <TextSmall>
          The invoice(s) seen above will be available as a PDF download or email
          attachment once you&apos;ve completed your check-out.
        </TextSmall>
      </div>
    </div>
  );
};

export default AllInvoices;
